import Layout from '@/views/main/Main.vue'
import type { RouteRecordRaw } from "vue-router";
const missionRouter: RouteRecordRaw = {
    path: '/mission',
    component: Layout,
    redirect: 'noredirect',
    meta: {
        icon: 'el-icon-user-solid',
        title: '任务管理'
    },
    children: [
        {
            path: '/mission/missionList',
            component: () => import("@/views/main/mission/missionList/missionList.vue"),
            name: 'missionList',
            meta: {
                title: '任务列表'
            }
        }]
}
//系统管理路由
export default missionRouter